import React from 'react';
import { Col, Row } from 'reactstrap';
import MonitoringHost from '../../../components/Widgets/MonitoringHost';
import MonitorUpTime from '../../../components/Widgets/Monitoring/MonitorUptime';
import TextWidget from '../../../components/Widgets/Monitoring/TextWidget';
import GaugeWidget from '../../../components/Widgets/Monitoring/GaugeWidget';
import { TMonitoredItem } from '../../../store/monitoredItem/types';
import LinkedServices from '../../../components/Widgets/LinkedServices';
import { IUserState } from '../../../store/user/types';

type TOwnProps = {
  item: TMonitoredItem;
  popUpHandler: (key: string, multiplier: number, format?: string, event?: React.MouseEvent<HTMLDivElement>) => any;
  user: IUserState;
};
const calculateUptime = (seconds: number) => {

  const output = {
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  };
  if ((seconds / 86400) >= 1) {

    output.days = Math.floor(seconds / 86400);
    seconds -= Math.floor((seconds / 86400)) * 86400;
  
  }
  if ((seconds / 3600) >= 1) {

    output.hours = Math.floor(seconds / 3600);
    seconds -= Math.floor((seconds / 3600)) * 3600;
  
  }
  if ((seconds / 60) >= 1) {

    output.minutes = Math.floor(seconds / 60);
    seconds -= Math.floor((seconds / 60)) * 60;
  
  }
  if (seconds > 0) {

    output.seconds = seconds;
  
  }

  return output;

};

const SRXTemplate: React.FC<TOwnProps> = (props) => {

  const { item, popUpHandler, user } = props;
  return (
    <Row className="d-flex align-items-stretch">

      <Col className="mb-2" md={4} lg={4}>
        <Row className="h-100">
          <Col className="mb-2" md={12}>
            <MonitoringHost
              name={item.name}
              location={item.location}
            />
          </Col>
          <Col className="mb-2" md={12}>
            <MonitorUpTime {...calculateUptime(item.uptime)} />
          </Col>
          <Col className="mb-2 mb-lg-0" md={12}>
            <LinkedServices
              services={item.services}
              user={user}
            />
          </Col>

        </Row>
      </Col>

      <Col className="mb-2" sm={12} md={8} lg={8}>
        <Row>

          <Col lg={6} xl={6} className="mb-2">
            <TextWidget value={item.flowSessions ? item.flowSessions : 0} title="Session Utilisation" measurementUnit="%" clickHandler={popUpHandler.bind(null, 'flowSessions', 1, '')} />
          </Col>
          <Col lg={6} xl={6} className="mb-2">
            <TextWidget title="latency" value={item.latency} measurementUnit="ms" clickHandler={popUpHandler.bind(null, 'latency', 1000, '')} />

          </Col>
          <Col lg={6} xl={6} className="mb-2">
            <GaugeWidget value={item.cpuSPU ? item.cpuSPU : 0} title="SPU Load" index={`${item.id}cpuSPU`} clickHandler={popUpHandler.bind(null, 'cpuSPU', 1, '')} />
          </Col>
          <Col lg={6} xl={6} className="mb-2">
            <GaugeWidget value={item.memorySPU ? item.memorySPU : 0} title="SPU Memory" index={`${item.id}memorySPU`} clickHandler={popUpHandler.bind(null, 'memorySPU', 1, '')} />
          </Col>
          <Col className="mb-2  mb-md-0 mb-lg-0" lg={6} xl={6}>
            <GaugeWidget value={item.memoryRE ? item.memoryRE : 0} title="RE Memory" index={`${item.id}memoryRE`} clickHandler={popUpHandler.bind(null, 'memoryRE', 1, '')} />

          </Col>
          <Col lg={6} xl={6} className="mb-2  mb-md-0 mb-lg-0">
            <GaugeWidget value={item.cpuRE ? item.cpuRE : 0} title="RE CPU Load" index={`${item.id}cpuRE`} clickHandler={popUpHandler.bind(null, 'cpuRE', 1, '')} />

          </Col>

        </Row>
      </Col>
    </Row>
  );

};

export default SRXTemplate;
